import { Component } from '@angular/core';

@Component({
  selector: 'adminapp-summary-graphic-abstract',
  templateUrl: './summary-graphic-abstract.component.html',
  styleUrls: ['./summary-graphic-abstract.component.scss']
})
export class SummaryGraphicAbstractComponent {

  constructor() { }
}
